import type { AuctionPhase } from "../../phase";

/** Prices as the legacy page printed them: up to four decimals, the reader's digits. */
export function formatPrice(value: number | string | null | undefined, isFa: boolean): string {
  const n = Number(value);
  if (!Number.isFinite(n)) return "—";
  return new Intl.NumberFormat(isFa ? "fa-IR" : "en-US", { minimumFractionDigits: 0, maximumFractionDigits: 4 }).format(n);
}

export function formatDateTime(value: string | null | undefined, isFa: boolean): string {
  if (!value) return "—";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "—";
  return new Intl.DateTimeFormat(isFa ? "fa-IR" : "en-US", { dateStyle: "medium", timeStyle: "short" }).format(d);
}

/** The phase in the reader's words — the listing's labels, so a tile and its page say the same thing. */
export const PHASE_LABEL: Record<AuctionPhase, [string, string]> = {
  live: ["در جریان", "Live"],
  "ending-soon": ["رو به پایان", "Ending soon"],
  upcoming: ["به‌زودی", "Upcoming"],
  finalising: ["در انتظار نتیجه", "Awaiting result"],
  settling: ["در حال تسویه", "Settling"],
  ended: ["پایان یافته", "Ended"],
  canceled: ["لغو شد", "Canceled"],
};

/** The backend's raw status, translated — the legacy details printed "active" in Persian too. */
export const STATUS_LABEL: Record<string, [string, string]> = {
  draft: ["پیش‌نویس", "Draft"],
  active: ["فعال", "Active"],
  settling: ["در حال تسویه", "Settling"],
  finished: ["تمام‌شده", "Finished"],
  canceled: ["لغوشده", "Canceled"],
};

export const BID_STATUS: Record<string, [string, string]> = {
  pending: ["در انتظار", "Pending"],
  accepted: ["تأییدشده", "Accepted"],
  rejected: ["ردشده", "Rejected"],
};
